module.exports = __webpack_public_path__ + "static/media/logo_brand_large.66e8d461.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_brand_large.png
// module id = 552
// module chunks = 0